import { useLayoutEffect, useState, type RefObject } from 'react'

/** The height that shows a table's first rows, so the rest scroll beneath them. */
export const useVisibleRowsMaxHeight = (
  containerRef: RefObject<HTMLElement | null>,
  visibleRowCount: number | undefined,
  rows: readonly unknown[]
): number | undefined => {
  const [maxHeightPx, setMaxHeightPx] = useState<number>()

  useLayoutEffect(() => {
    const container = containerRef.current
    const hasMoreRowsThanShown = visibleRowCount !== undefined && rows.length > visibleRowCount

    if (!container || !hasMoreRowsThanShown) {
      setMaxHeightPx(undefined)
      return
    }

    const shownRows = Array.from(container.querySelectorAll('tbody tr')).slice(0, visibleRowCount)
    const rowsHeightPx = shownRows.reduce((total, row) => total + row.getBoundingClientRect().height, 0)
    setMaxHeightPx(rowsHeightPx > 0 ? rowsHeightPx : undefined)
  }, [containerRef, visibleRowCount, rows])

  return maxHeightPx
}
